import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "evolution-chart-exporter",
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "width": "100%",
    "height": "100%",
    "z-index": "-1",
    "pointer-events": "none"
  }
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_show_must_login = _resolveComponent("show-must-login");
  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createElementVNode("div", null, [(_openBlock(), _createBlock(_component_router_view, {
    key: $data.componentKey
  })), $data.showMustLogin ? (_openBlock(), _createBlock(_component_show_must_login, {
    key: 0
  })) : _createCommentVNode("", true)])], 64);
}